import { render, staticRenderFns } from "./InventoryRoom.vue?vue&type=template&id=000bd630&"
import script from "./InventoryRoom.vue?vue&type=script&lang=ts&"
export * from "./InventoryRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports